import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  clearUrlData,
  // getBatchDocuments,
  getBatchLogFiltersData,
  getBatchOrProjectLogs,
  // getBatchParameters,
  // getBatchesTilesOfProject,
  getDataForExport,
} from "../../../redux/investigation/actions";
import Label from "../../../components/Label/Label";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import SearchIcon from "@mui/icons-material/Search";

const DynamicEllipsisComponent = ({ value }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const labelRef = useRef(null);

  useEffect(() => {
    const checkOverflow = () => {
      const label = labelRef.current;
      if (label) {
        const isOverflowing = label.offsetWidth < label.scrollWidth;
        setShowTooltip(isOverflowing);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, []);

  return (
    <>
      {showTooltip ? (
        <Tooltip title={value || ""} arrow>
          <div
            ref={labelRef}
            style={{
              fontSize: "12px",
              fontWeight: "600",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              wordBreak: "normal",
            }}
            className="label"
          >
            {value || "-"}
          </div>
        </Tooltip>
      ) : (
        <div
          ref={labelRef}
          style={{
            fontSize: "12px",
            fontWeight: "600",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            wordBreak: "normal",
          }}
          className="label"
        >
          {value || "-"}
        </div>
      )}
    </>
  );
};

const RenderActivityOnlyLog = ({ log }) => (
  <Box style={{ padding: "10px 5px" }}>
    <Box style={{ borderLeft: "5px solid #408BFC", paddingLeft: "10px" }}>
      <Box style={{ display: "flex", justifyContent: "space-between" }}>
        <Label
          text={log?.activity_date_time}
          fontSize="10px"
          fontWeight="500"
        />

        <Box style={{ display: "flex" }}>
          <Label
            text={`User Role -  ${log?.user_group}`}
            fontSize="10px"
            fontWeight="500"
          />
        </Box>
        <Box style={{ display: "flex" }}>
          <Label
            text={`User Name -  ${log?.username}`}
            fontSize="10px"
            fontWeight="500"
          />
        </Box>
      </Box>

      <Grid container spacing={1} sx={{ paddingTop: "10px" }}>
        <Grid item xs={6}>
          <Label text="Activity" fontSize="10px" fontWeight="500" />

          <DynamicEllipsisComponent value={log?.activity_name} />
        </Grid>

        <Grid item xs={3}>
          <Label text="Value" fontSize="10px" fontWeight="500" />
          <DynamicEllipsisComponent value={log?.value} />
        </Grid>
      </Grid>

      <Grid container spacing={1} sx={{ paddingTop: "10px" }}>
        <Grid item xs={6}>
          <Label text="Parameter Name" fontSize="10px" fontWeight="500" />

          <DynamicEllipsisComponent value={log?.parameter_name} />
        </Grid>

        <Grid item xs={3}>
          <Label text="Data Type" fontSize="10px" fontWeight="500" />
          <Label
            text={log?.data_type || " - "}
            fontSize="12px"
            fontWeight="600"
          />
        </Grid>
        <Grid item xs={3}>
          <Label
            text={
              log?.range_min && log?.range_max
                ? "Range Min Max"
                : log?.range_min
                  ? "Range Min"
                  : log?.range_max
                    ? "Range Max"
                    : "Range"
            }
            fontSize="10px"
            fontWeight="500"
          />
          <Label
            text={
              log?.range_min && log?.range_max
                ? `${log?.range_min} - ${log?.range_max}`
                : log?.range_min
                  ? `${log?.range_min}`
                  : log?.range_max
                    ? `${log?.range_max}`
                    : "-"
            }
            fontSize="12px"
            fontWeight="600"
          />
        </Grid>
      </Grid>

      <Grid container spacing={1} sx={{ paddingTop: "10px" }}>
        <Grid item xs={6}>
          <Label text="Document" fontSize="10px" fontWeight="500" />
          <DynamicEllipsisComponent value={log?.pdf_name} />
        </Grid>

        <Grid item xs={3}>
          <Label text="Page No" fontSize="10px" fontWeight="500" />
          <Label
            text={parseInt(log?.page_number) + 1 || "-"}
            fontSize="12px"
            fontWeight="600"
          />
        </Grid>
        <Grid item xs={2}>
          <Label text="Index" fontSize="10px" fontWeight="500" />
          <Label
            text={`Row - ${
              log?.row_index !== null ? log?.row_index : ""
            }, Column - ${log?.col_index !== null ? log?.col_index : ""}`}
            fontSize="12px"
            fontWeight="600"
          />
        </Grid>
        {(log?.activity_name === "Rejected" ||
          log?.activity_name === "Cell Rejected" ||
          log?.activity_name === "Row Rejected" ||
          log?.activity_name === "Batch Rejected By Validator" ||
          log?.activity_name === "Batch Rejected By Administrator" ||
          log?.activity_name === "Batch Rejected By Processor" ||
          log?.activity_name === "Rejected validated data" ||
          log?.activity_name === "Rejected mapping") &&
          log?.rejection_remark && (
            <Grid item xs={12}>
              <Label text="Rejction Remark" fontSize="10px" fontWeight="500" />
              <Label
                text={log?.rejection_remark || " - "}
                fontSize="12px"
                fontWeight="600"
              />
            </Grid>
          )}
      </Grid>
    </Box>
  </Box>
);

const RenderActivityDataLog = ({ log }) => (
  <Box style={{ padding: "10px 5px" }}>
    <Box style={{ borderLeft: "5px solid #408BFC", paddingLeft: "10px" }}>
      <Box style={{ display: "flex", justifyContent: "space-between" }}>
        <Label
          text={log?.activity_date_time}
          fontSize="10px"
          fontWeight="500"
        />
        <Box style={{ display: "flex" }}>
          <Label
            text={`User Role - ${log?.user_group}`}
            fontSize="10px"
            fontWeight="500"
          />
        </Box>
        <Box style={{ display: "flex" }}>
          <Label
            text={`User Name - ${log?.username}`}
            fontSize="10px"
            fontWeight="500"
          />
        </Box>
      </Box>
      <Label
        text="Activity"
        fontSize="10px"
        fontWeight="500"
        paddingTop="10px"
      />
      <DynamicEllipsisComponent value={log.activity_name} />
      <Label
        text="Activity Data"
        fontSize="10px"
        fontWeight="500"
        paddingTop="10px"
      />
      <Label
        fontSize="12px"
        fontWeight="600"
        textAlign="left"
        padding="10px"
        isComponentToShow={true}
        text={
          log?.activity_data !== null &&
          Array.isArray(log?.activity_data) === true
            ? (() => {
                return log.activity_data.map((item, index) => (
                  <React.Fragment key={index}>
                    {typeof item === "object" &&
                      Object.entries(item).map(([key, value]) => (
                        <>
                          <Label fontSize="10px" text={`${key}:`} />
                          <Label
                            fontSize="11px"
                            text={value}
                            fontWeight={600}
                          />
                        </>
                      ))}
                    {index !== log.activity_data.length - 1 && <br />}
                  </React.Fragment>
                ));
              })()
            : log?.activity_data !== null &&
                typeof log?.activity_data === "object"
              ? (() => {
                  const keyValuePairs = Object.entries(log?.activity_data);
                  return keyValuePairs.length > 0
                    ? keyValuePairs.map(([key, value]) => (
                        <>
                          <Label fontSize="10px" text={`${key}:`} />

                          {Array.isArray(value) === true ? (
                            value.map((item) => (
                              <>
                                <Label
                                  fontSize="11px"
                                  text={item}
                                  fontWeight={600}
                                />
                              </>
                            ))
                          ) : (
                            <Label
                              fontSize="11px"
                              text={value}
                              fontWeight={600}
                            />
                          )}
                        </>
                      ))
                    : "-";
                })()
              : log?.activity_data || "-"
        }
      />
      {(log?.activity_name === "Rejected" ||
        log?.activity_name === "Cell Rejected" ||
        log?.activity_name === "Row Rejected" ||
        log?.activity_name === "Batch Rejected By Validator" ||
        log?.activity_name === "Batch Rejected By Administrator" ||
        log?.activity_name === "Batch Rejected By Processor" ||
        log?.activity_name === "Rejected validated data" ||
        log?.activity_name === "Rejected mapping") &&
        log?.rejection_remark && (
          <>
            {" "}
            <Label text="Rejection  Remark" fontSize="10px" fontWeight="500" />
            <Label
              text={log?.rejection_remark || " - "}
              fontSize="12px"
              fontWeight="600"
            />
          </>
        )}
    </Box>
  </Box>
);

export const ProjectLogs = ({
  seletedTileBatchName,
  projectName,
  selectedDetails,
  closeLogDrawer,
}) => {
  const dispatch = useDispatch();

  const urlData = useSelector((state) => state?.investigation?.urlData);

  const [exportLoader, setExportLoader] = useState(urlData?.loader || false);

  useEffect(() => {
    if (selectedDetails?.type === "batch") {
      dispatch(getBatchLogFiltersData(selectedDetails?.batch_id));
      dispatch(
        getBatchOrProjectLogs(selectedDetails?.batch_id, selectedDetails?.type),
      );
    } else {
      dispatch(
        getBatchOrProjectLogs(
          selectedDetails?.project_id,
          selectedDetails?.type,
        ),
      );
    }
  }, []);

  useEffect(() => {
    if (urlData?.loader === false) {
      setExportLoader(false);
      if (urlData?.apiError === false && urlData?.url?.data) {
        window.open(urlData?.url?.data, "_blank");

        dispatch(clearUrlData());
      }
    }
  }, [urlData]);

  const batchLogs = useSelector(
    (state) => state?.investigation?.batchLogs || [],
  );
  const logsApiStatus = useSelector(
    (state) => state?.investigation?.logsApiStatus,
  );
  const batchFiltersData = useSelector(
    (state) => state?.investigation?.batchFiltersData,
  );

  const [batchDetailsFilters, setBatchDetailsFilters] = useState({
    role: "",
    document: "",
    activity: "",
    parameter: "",
  });

  const handleChangeBatchDetail = (value, key) => {
    setBatchDetailsFilters({
      ...batchDetailsFilters,
      [key]: value,
    });
  };

  const onCLickSearchDetailsBatchLogs = () => {
    dispatch(
      getBatchOrProjectLogs(
        selectedDetails?.batch_id,
        selectedDetails?.type,
        batchDetailsFilters,
      ),
    );
  };

  const onClickExportLogParent = (selectedValues) => {
    dispatch(getDataForExport(selectedValues));

    setExportLoader(true);
  };

  return (
    <Box
      sx={{
        paddingTop: "10px",
        paddingLeft: "10px",
      }}
    >
      <Box
        style={{
          position: "sticky",
          top: 0,
          backgroundColor: "white",
          zIndex: 1000,
        }}
      >
        <Box
          style={{
            backgroundColor: "#9CCAFF",
            height: "40px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: "10px",
            border: "2px solid #408BFC",
          }}
        >
          <Label
            text={
              selectedDetails?.type === "batch"
                ? `${`${selectedDetails?.project_name} / ${selectedDetails?.batch_name}`}`
                : `${`${selectedDetails?.project_name}`}`
            }
            fontSize="14px"
            fontWeight="600"
          />

          <Button
            variant="text"
            startIcon={<CloseIcon />}
            style={{ color: "black", textTransform: "none" }}
            onClick={() => closeLogDrawer()}
          >
            Close
          </Button>
        </Box>
        {selectedDetails?.type === "batch" && (
          <Box>
            <Grid container spacing={1} sx={{ paddingTop: "10px" }}>
              <Grid item xs={2.5}>
                <FormControl fullWidth size="small">
                  <InputLabel id="drug-product-label">Role</InputLabel>
                  <Select
                    labelId="drug-product-label"
                    id="drug-product-select"
                    value={batchDetailsFilters?.role}
                    label="Role"
                    onChange={(event) =>
                      handleChangeBatchDetail(event.target.value, "role")
                    }
                    className="select-box"
                    IconComponent={({ open }) => (
                      <>
                        {open || !batchDetailsFilters?.role ? (
                          <ArrowDropDownIcon />
                        ) : (
                          <IconButton
                            size="small"
                            onMouseDown={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              handleChangeBatchDetail(null, "role");
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        )}
                      </>
                    )}
                  >
                    {batchFiltersData?.user_groups?.map((user, index) => (
                      <MenuItem key={user} value={user}>
                        {user}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2.5}>
                <FormControl fullWidth size="small">
                  <InputLabel id="project-name-label">Activity</InputLabel>
                  <Select
                    labelId="project-name-label"
                    id="project-name-select"
                    value={batchDetailsFilters?.activity}
                    label="Document"
                    onChange={(event) =>
                      handleChangeBatchDetail(event.target.value, "activity")
                    }
                    size="small"
                    className="select-box"
                    IconComponent={({ open }) => (
                      <>
                        {open || !batchDetailsFilters?.activity ? (
                          <ArrowDropDownIcon />
                        ) : (
                          <IconButton
                            size="small"
                            onMouseDown={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              handleChangeBatchDetail(null, "activity");
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        )}
                      </>
                    )}
                  >
                    {batchFiltersData?.activity_names?.map(
                      (activity, index) => (
                        <MenuItem key={activity} value={activity}>
                          {activity}
                        </MenuItem>
                      ),
                    )}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={2.5}>
                <FormControl fullWidth size="small">
                  <InputLabel id="project-name-label">Document</InputLabel>
                  <Select
                    labelId="project-name-label"
                    id="project-name-select"
                    value={batchDetailsFilters?.document}
                    label="Document"
                    onChange={(event) =>
                      handleChangeBatchDetail(event.target.value, "document")
                    }
                    size="small"
                    className="select-box"
                    IconComponent={({ open }) => (
                      <>
                        {open || !batchDetailsFilters?.document ? (
                          <ArrowDropDownIcon />
                        ) : (
                          <IconButton
                            size="small"
                            onMouseDown={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              handleChangeBatchDetail(null, "document");
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        )}
                      </>
                    )}
                  >
                    {batchFiltersData?.documents?.map((document, index) => (
                      <MenuItem key={document} value={document}>
                        {document}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2.5}>
                <FormControl fullWidth size="small">
                  <InputLabel id="user-name-label">Parameter</InputLabel>
                  <Select
                    labelId="user-name-label"
                    id="user-name-select"
                    value={batchDetailsFilters?.parameter}
                    label="Parameter"
                    onChange={(event) =>
                      handleChangeBatchDetail(event.target.value, "parameter")
                    }
                    size="small"
                    className="select-box"
                    IconComponent={({ open }) => (
                      <>
                        {open || !batchDetailsFilters?.parameter ? (
                          <ArrowDropDownIcon />
                        ) : (
                          <IconButton
                            size="small"
                            onMouseDown={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              handleChangeBatchDetail(null, "parameter");
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        )}
                      </>
                    )}
                  >
                    {batchFiltersData?.parameters?.map((parmeter, index) => (
                      <MenuItem key={parmeter} value={parmeter}>
                        {parmeter}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item>
                <Tooltip arrow title="Search">
                  <Button
                    size="medium"
                    variant="contained"
                    sx={{ minWidth: "auto", padding: 1 }}
                    onClick={() => onCLickSearchDetailsBatchLogs()}
                  >
                    <SearchIcon />
                  </Button>
                </Tooltip>
              </Grid>

              <Grid item>
                <Tooltip arrow title="Export">
                  <Button
                    size="medium"
                    onClick={() => onClickExportLogParent(batchLogs)}
                    variant="contained"
                    sx={{ minWidth: "auto", padding: 1 }}
                    disabled={exportLoader}
                  >
                    {exportLoader ? (
                      <CircularProgress size={24} />
                    ) : (
                      <FileDownloadIcon />
                    )}
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          </Box>
        )}
        {selectedDetails?.type === "project" && (
          <>
            <Box
              sx={{
                paddingTop: "5px",
                right: 0,
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Grid item>
                <Tooltip arrow title="Export">
                  <Button
                    size="medium"
                    onClick={() => onClickExportLogParent(batchLogs)}
                    variant="contained"
                    sx={{ minWidth: "auto", padding: 1 }}
                    disabled={exportLoader}
                  >
                    {exportLoader ? (
                      <CircularProgress size={24} />
                    ) : (
                      <FileDownloadIcon />
                    )}
                  </Button>
                </Tooltip>
              </Grid>
            </Box>
          </>
        )}
        <Divider
          orientation="horizontal"
          flexItem
          sx={{ paddingTop: "10px" }}
        />
      </Box>

      {logsApiStatus?.loader ? (
        <Box style={{ paddingRight: "24px" }}>
          <DashboardTableSkaleton />
        </Box>
      ) : batchLogs?.length > 0 ? (
        batchLogs.map((log, index) => (
          <React.Fragment key={index}>
            {log?.user_activity ? (
              <RenderActivityDataLog log={log} />
            ) : (
              <RenderActivityOnlyLog log={log} />
            )}
            <Divider orientation="horizontal" flexItem />
          </React.Fragment>
        ))
      ) : (
        <div className="no-data">
          <Label
            text="No Data Found"
            fontSize="16"
            fontWeight="600"
            padding="20px"
          />
        </div>
      )}
      {urlData?.apiError === true && (
        <CustomizedSnackbars
          severity="error"
          state={urlData?.apiError}
          text={urlData?.message}
          handleClose={() => {
            dispatch(clearUrlData());
          }}
        />
      )}
    </Box>
  );
};
